/* eslint-disable */
import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import useFormValidator from 'useFormValidator';
import DateInputPicker from 'modules/common/components/DateInputPicker2';
import PropTypes from 'prop-types';
import moment from 'moment';
import { ModalContext } from 'App';
import * as c from '../constant';
import * as actions from '../action';

function UpdateModal({
  updateDiscountPenalty,
  getDiscountPenaltyList,
  updateList,
  history,
  updating,
}) {
  const [formData, setFormData] = useState({
    additional_monthly_penalty_percentage: '',
    date_before_penalty_start: '',
    discount_percentage: '',
    initial_penalty_percentage: '',
    last_date_with_discount: '',
    maximum_penalty_percentage: '',
    month_day_before_penalty_update: '',
    year: '',
    gross_additional_percentage: '',
  });

  const validateForm = useFormValidator(formData, {
    date_before_penalty_start: 'required|date',
    last_date_with_discount: 'required|date',
    gross_additional_percentage: 'required|number',
  });

  const setModal = useContext(ModalContext);

  const handleOnSubmit = e => {
    e.preventDefault();

    const args = {
      date_before_penalty_start: moment(
        _.get(formData, 'date_before_penalty_start')
      ).format('YYYY-MM-DD'),
      last_date_with_discount: moment(
        _.get(formData, 'last_date_with_discount')
      ).format('YYYY-MM-DD'),
      gross_additional_percentage: _.get(
        formData,
        'gross_additional_percentage'
      ),
    };

    updateDiscountPenalty(args, () => {
      setModal({ isOpen: false });
      getDiscountPenaltyList();
      history.push(`/bpls/settings/discount-penalty`);
    });
  };

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onSetFormData = () => {
    if (!_.isEmpty(updateList)) {
      const args = {
        ...updateList,
      };
      setFormData(_.pick(args, _.keys(c.FORM_DATA)));
    }
  };

  useEffect(() => {
    onSetFormData();
  }, []);

  const onChangeDate = key => ({ target: { value } }) => {
    setFormData({
      ...formData,
      [key]: value,
    });
  };

  const onChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label
              htmlFor="last_date_with_discount"
              className="full-label mb-0"
            >
              Last Date with Discount:
              {validateForm.renderMessage('last_date_with_discount')}
            </label>
            <DateInputPicker
              className="form-control"
              dateFormat="MM/DD/YYYY"
              onChange={onChangeDate('last_date_with_discount')}
              value={_.get(formData, 'last_date_with_discount')}
            />
          </div>
          <div className="col-12 form-group">
            <label
              htmlFor="date_before_penalty_start"
              className="full-label mb-0"
            >
              Date Before Penalty Start:
              {validateForm.renderMessage('date_before_penalty_start')}
            </label>
            <DateInputPicker
              className="form-control"
              dateFormat="MM/DD/YYYY"
              onChange={onChangeDate('date_before_penalty_start')}
              value={_.get(formData, 'date_before_penalty_start')}
            />
          </div>
          <div className="col-12 form-group">
            <label
              htmlFor="gross_additional_percentage"
              className="full-label mb-0"
            >
              Gross Additional Percentage:
              {validateForm.renderMessage('gross_additional_percentage')}
            </label>
            <input
              className="form-control"
              type="text"
              name="gross_additional_percentage"
              onChange={onChange}
              value={_.get(formData, 'gross_additional_percentage') || ''}
            />
          </div>
        </div>

        <div className="d-flex justify-content-center">
          <button
            disabled={updating || !validateForm.response.is_passed}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary     mr-3"
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>{' '}
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateModal.propTypes = {
  updateList: PropTypes.instanceOf(Object).isRequired,
  updateDiscountPenalty: PropTypes.instanceOf(Function).isRequired,
  getDiscountPenaltyList: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  updating: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  updating: api.loading.indexOf(c.UPDATE_DISCOUNT_PENALTY) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(UpdateModal);
